import { render, staticRenderFns } from "./ComplaintAllInfo1.vue?vue&type=template&id=6f3bbfd5&scoped=true&"
import script from "./ComplaintAllInfo1.vue?vue&type=script&lang=js&"
export * from "./ComplaintAllInfo1.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintAllInfo1.vue?vue&type=style&index=0&id=6f3bbfd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3bbfd5",
  null
  
)

export default component.exports